import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

// ---------------------------------------------------------
// LIST
// ---------------------------------------------------------
export async function getProjectsApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);

    fd.append("search", payload.search || "");

    fd.append(
      "course_id",
      payload.course_id || ""
    );

    fd.append(
      "category_id",
      payload.category_id || ""
    );

    fd.append(
      "creator_id",
      payload.creator_id || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/projects/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Projects Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Projects fetch failed",
    };
  }
}

// ---------------------------------------------------------
// STATS
// ---------------------------------------------------------
export async function getProjectStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/projects/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error(
      "Get Project Stats Error:",
      err
    );

    return {
      status: false,
      type: "danger",
      success: "Project stats fetch failed",
    };
  }
}

// ---------------------------------------------------------
// VIEW
// ---------------------------------------------------------
export async function getProjectApi(projectId) {
  try {
    const fd = new FormData();

    fd.append(
      "project_id",
      projectId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/projects/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error(
      "Get Project Error:",
      err
    );

    return {
      status: false,
      type: "danger",
      success: "Project fetch failed",
    };
  }
}

// ---------------------------------------------------------
// CREATE
// ---------------------------------------------------------
export async function createProjectApi(
  payload = {}
) {
  try {
    const fd = new FormData();

    fd.append(
      "project_parent",
      payload.project_parent || ""
    );

    fd.append(
      "project_parent_type",
      payload.project_parent_type || ""
    );

    fd.append(
      "project_cat",
      payload.project_cat || ""
    );

    fd.append(
      "project_img",
      payload.project_img || ""
    );

    fd.append(
      "project_title",
      payload.project_title || ""
    );

    fd.append(
      "project_meta_title",
      payload.project_meta_title || ""
    );

    fd.append(
      "project_keywords",
      payload.project_keywords || ""
    );

    fd.append(
      "project_duration",
      payload.project_duration ?? ""
    );

    fd.append(
      "project_video",
      payload.project_video || ""
    );

    fd.append(
      "project_by",
      payload.project_by || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/projects/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error(
      "Create Project Error:",
      err
    );

    return {
      status: false,
      type: "danger",
      success: "Project creation failed",
    };
  }
}

// ---------------------------------------------------------
// UPDATE
// ---------------------------------------------------------
export async function updateProjectApi(
  payload = {}
) {
  try {
    const fd = new FormData();

    fd.append(
      "project_id",
      payload.project_id || ""
    );

    fd.append(
      "project_parent",
      payload.project_parent || ""
    );

    fd.append(
      "project_parent_type",
      payload.project_parent_type || ""
    );

    fd.append(
      "project_cat",
      payload.project_cat || ""
    );

    fd.append(
      "project_img",
      payload.project_img || ""
    );

    fd.append(
      "project_title",
      payload.project_title || ""
    );

    fd.append(
      "project_meta_title",
      payload.project_meta_title || ""
    );

    fd.append(
      "project_keywords",
      payload.project_keywords || ""
    );

    fd.append(
      "project_duration",
      payload.project_duration ?? ""
    );

    fd.append(
      "project_video",
      payload.project_video || ""
    );

    fd.append(
      "project_by",
      payload.project_by || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/projects/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error(
      "Update Project Error:",
      err
    );

    return {
      status: false,
      type: "danger",
      success: "Project update failed",
    };
  }
}

// ---------------------------------------------------------
// DELETE
// ---------------------------------------------------------
export async function deleteProjectApi(
  projectId
) {
  try {
    const fd = new FormData();

    fd.append(
      "project_id",
      projectId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/projects/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error(
      "Delete Project Error:",
      err
    );

    return {
      status: false,
      type: "danger",
      success: "Project deletion failed",
    };
  }
}